import charcreate from "../../_helper/charcreate";
import React, {Fragment, useEffect, useState} from "react";
import {s_char, s_char_skills, s_char_talents} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ClearIcon from "@mui/icons-material/Clear";
import {s_app_sl} from "../../_signals/s_app";
import {v4} from "uuid";
import {TalentsCreate, TalentsUpdate} from "../../_api/BETalents";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {Checkbox, ListItemText, OutlinedInput} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {SkillsUpdate} from "../../_api/BESkills";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";

interface IProp {
    edit: string,
    isOpen: (id: string) => void
}

function TalentsEdit({edit, isOpen}: IProp) {
    useSignals();

    const [talent, setTalent] = useState<ICharTalent | null>(null)

    useEffect(() => {
        const fd = s_char_talents.value.find(d => d.id === edit);
        if (fd) setTalent(fd)
        else setTalent(null)
    }, [edit])

    const talentOptionDifficulty = (lps: number) => {
        if (lps === 100) return 'Novize';
        if (lps === 200) return 'Geselle';
        if (lps === 300) return 'Hüter';
        if (lps === 500) return 'Meister';
        return '';
    }

    const raise = () => {
        if (!talent) return;
        const nsc = s_char.value.nsc;
        if (nsc && !s_app_sl.value) return;

        let lp_current = s_char.value.lp_current;
        const no_lp = nsc && s_app_sl.value;

        let update = false;


        const nextStep = talent.step + 1;
        let lpstart = talent.lpstart;
        let cost = charcreate.raiseCost(lpstart, nextStep);

        if (no_lp) {
            talent.step = nextStep;
            update = true;
        } else if (cost > 0) {
            if (cost < lp_current) {
                if (window.confirm('Kosten ' + cost + ' Steigerung Talent ' + talent.name + ' auf ' + nextStep)) {
                    lp_current = lp_current - cost;
                    talent.step = nextStep;
                    update = true;
                }
            } else alert('Zu wenig LP');
        } else alert('LP kosten fehler');

        if (update) {
            if (talent.name === 'Vielseitigkeit') {
                const toAdd: ICharTalent = {
                    id: v4(),
                    cid: s_char.value.id,
                    name: "",
                    attribute: "",
                    action: "",
                    strain: 0,
                    discipline: "Vielseitigkeit",
                    lpstart: 100, // FIXME passt das? wann gelernt wo wie? kosten? circle?
                    circle: nextStep,
                    descr: "",
                    optional: false,
                    karma: false,
                    free: false,
                    step: 0,
                    stepfree: 0,
                    define: []
                }
                s_char_talents.value = [...s_char_talents.value.map(t => {
                    if (t.id !== talent.id) return t
                    else return talent
                }), toAdd]

                TalentsCreate([toAdd])
            } else {
                s_char_talents.value = s_char_talents.value.map(t => {
                    if (t.id !== talent.id) return t
                    else return talent
                })
            }

            const time = new Date().toISOString();
            const lpc:ICharLPChanges = {
                id: v4(),
                cid: s_char.value.id,
                ts: time,
                entry: '-' + cost + ' Steigerung Talent ' + talent.name + ' auf ' + nextStep
            }
            LPChangesCreate(lpc)
            TalentsUpdate([talent])
        }
    }

    const canRaise = () => {
        if (!talent) return false;
        return charcreate.raiseCost(talent.lpstart, talent.step + 1) <= s_char.value.lp_current
    }

    const handleDefineMultiChange = (event, talentid) => {
        const {
            target: {value},
        } = event;

        let talents = s_char_talents.value

        const values = typeof value === 'string' ? value.split(',') : value;

        let update = false
        talents = talents.map(t => {
            if (t.id === talentid) {
                if (t.step >= values.length) {
                    t.define = values;
                    TalentsUpdate([t]);
                    update = true
                } else alert('Talent zu niedrig')
            }
            return t;
        });
        if (update) s_char_talents.value = talents
    };

    return <Fragment>
        <Dialog open={edit !== ''}>
            <DialogContent>
                <div key={'dedc1'}>
                    Talent: {talent?.name}
                </div>
                {talent?.discipline === 'Mensch' ? <div key={'dedc2'}>
                        gelernt mit Vielseitigkeit
                    </div> :
                    <div key={'dedc2'}>
                        {talent?.optional ?
                            talent?.discipline + ' Option: ' + talentOptionDifficulty(talent.lpstart)
                            :
                            talent?.discipline + ' Kreis: ' + talent?.circle
                        }
                    </div>

                }
                <div key={'dedc3'}>
                    Stufe: {talent?.step}
                </div>
                {talent?.hasOwnProperty('define_multi') && talent?.define_multi!.length > 0 ?
                    <div key={'dedc4'}>
                    <FormControl sx={{m: 1}}>
                        <Select
                            multiple
                            value={talent.define}
                            onChange={(event) => handleDefineMultiChange(event, talent.id)}
                            input={<OutlinedInput label="Tag"/>}
                            renderValue={(selected) => selected.join(', ')}
                        >
                            {talent.define_multi?.map((name) => (
                                <MenuItem key={name} value={name}>
                                    <Checkbox
                                        checked={
                                            talent.define.indexOf(name) > -1
                                        }/>
                                    <ListItemText primary={name}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    </div>
                    :
                    null
                }
                {talent?.lpstart ? <div key={'dedc3'}>
                    Kosten nächste
                    Stufe: {charcreate.raiseCost(talent?.lpstart, (talent?.step ? talent.step + 1 : 0))}
                </div> : null}
                <div key={'dedc4'}>
                    {!canRaise() ? 'Zuwenig' : 'Verfügbare'} Legendenpunkte: {s_char.value.lp_current}
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={!canRaise()}
                        onClick={() => raise()}><ArrowUpwardIcon/></Button>
                <Button onClick={() => isOpen('')}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default TalentsEdit